<!-- 教师签到 table -->
<template>
  <table-view
    class="teacher-app-sign-view"
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable">
    <template #header>
      <view-search-form
        keyword-placeholder="教职工名"
        :queryInfo.sync="queryInfo"
        :tool-list="['department','keyword','college']"
        :filter-keys="['userType']"
        @on-search="renderTable(1)">
        <el-form-item label="是否连续签到" label-width="100px">
          <el-radio-group v-model="queryInfo.continueFlag" size="small">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签到总天数" label-width="88px">
          <el-select v-model="queryInfo.signCount" clearable style="width: 180px;" size="small">
            <el-option
              v-for="{paramValue,paramName} in signCountList"
              :key="paramValue"
              :label="paramName"
              :value="paramValue" />
          </el-select>
        </el-form-item>
      </view-search-form>
    </template>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="userName" label="用户名" width="140px" />
      <el-table-column prop="signTime" label="签到时间" width="200px" />
      <el-table-column label="部门/院系">
        <template v-slot="{row}">
          {{ row.deptName ? row.deptName : (row.collegeName ? row.collegeName : '') }}
        </template>
      </el-table-column>
    </el-table>
  </table-view>
</template>
<script>
import tableView from '@/vue/mixins/table-view'
import { pageAppSignApi } from '@/api/app-manage/app-sign-api'

export default {
  name: 'teacherAppSignView',
  mixins: [tableView],
  props: {
    signCountList: { // 签到总天数 类型
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      queryInfo: {
        collegeId: null,
        deptId: null,
        signCount: null,
        continueFlag: 0,
        userType: 3
      }
    }
  },
  watch: {
    'queryInfo.collegeId': function (newVal) {
      if (newVal) this.queryInfo.deptId = null
    },
    'queryInfo.deptId': function (newVal) {
      if (newVal) this.queryInfo.collegeId = null
    }
  },
  async mounted () {
    await this.renderTable(1)
  },
  methods: {
    async renderTable (pageNum) {
      await this.getTableData(pageAppSignApi, pageNum)
    }
  }
}
</script>
